const encaminhar_alunos_reordenados = {
  path: "/encaminhar-alunos-reordenados",
  redirect: "/encaminhar-alunos-reordenados",
  meta: {
    breadCrumb:
      "Processo de Matrículas - Permitir Encaminhar Alunos Reordenados",
  },
  children: [
    {
      path: "/encaminhar-alunos-reordenados",
      name: "encaminhar-alunos-reordenados",
      component: () =>
        import(
          "@/views/EncaminharAlunosReordenados/EncaminharAlunosReordenadosHome.vue"
        ),
    },
  ],
};

export { encaminhar_alunos_reordenados };
